import api from './api';

export interface ContratadoAno {
    requisicaoCompraSeqId: string;
    ano: string;
    semVinculoComOi: boolean;
}


export const CreateContratadoAnoAnoReferencia = (form: ContratadoAno) => api.post(`contratopcs/createContratadoAnoAnoReferencia`, form);